// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6ba1b66d","703":"c144b135","787":"def8287d"}[chunkId] + ".chunk.js";
};